import { BulkResponseDTO, AnalysisResponseDTO, BulkUploadDTO, ApiResponseStatus } from "@/api/bulk/types";
import * as api from "@/api/bulk";
import { isPolygon, intersectsItself } from "@/helpers/geometry";
import { geometryFromGeojson } from "@/helpers/geojson";


export async function create(dto: BulkUploadDTO): Promise<BulkResponseDTO | undefined> {
  try {
    return await api.create(dto);
  } catch (err) {
    const response = new BulkResponseDTO();
    response.ownerStatus = ApiResponseStatus.BACKEND_ERROR;
    return Promise.resolve(response);
  }
}

export enum ValidationResponse {
  VALID,
  INVALID_POINT,
  NOT_ONLY_ONE_GEOM,
  NO_OWNER_ID,
  NO_FARM_NAME,
  INVALID_GEOMETRY,
  NO_CROP_TYPE,
}

export function validateBulkRecord(record: BulkUploadDTO): ValidationResponse {
  if (!hasValidPointFormat(record)) { return ValidationResponse.INVALID_POINT; }
  if (!hasOnlyOneGeometry(record)) { return ValidationResponse.NOT_ONLY_ONE_GEOM; }
  if (!hasOwnerId(record)) { return ValidationResponse.NO_OWNER_ID; }
  if (!hasFarmName(record)) { return ValidationResponse.NO_FARM_NAME; }
  if (!hasValidGeometry(record)) { return ValidationResponse.INVALID_GEOMETRY; }
  if (!hasCropType(record)) { return ValidationResponse.NO_CROP_TYPE; }
  return ValidationResponse.VALID;
}


function hasOnlyOneGeometry(record: BulkUploadDTO) {
  const geomFields= [record.lat ?? record.lng, record.geom, record.carCode, record.incraAllotment];
  const inRecord = geomFields.filter(f => (f ?? null) !== null);
  return inRecord.length === 1;
}

function hasValidPointFormat(record: BulkUploadDTO) {
  return ((record.lat ?? null) !== null) === ((record.lng ?? null) !== null);
}

function hasOwnerId(record: BulkUploadDTO) {
  return ((record.ownerName ?? null) === null) || ((record.ownerId ?? null) !== null);
}

function hasFarmName(record: BulkUploadDTO) {
  return ((record.geom ?? null) === null) || ((record.farmName ?? null) !== null);
}

function hasValidGeometry(record: BulkUploadDTO) {
  if ((record.geom ?? null) !== null) {
    const geometry = geometryFromGeojson(record.geom!);
    return isPolygon(geometry) && !intersectsItself(geometry)
  }
  return true;
}

function hasCropType(record: BulkUploadDTO) {
  return (!(record.analitica || record.sentinela) || ((record.cropType1 ?? null) !== null) || ((record.cropType2 ?? null) !== null));
}
